/**
 * Saves a blob to the user's downloads under the given name, by clicking a throwaway anchor.
 * The object URL is revoked on the next tick rather than immediately, because Firefox cancels
 * a download whose URL is released before the click has been dispatched.
 *
 * @param blob - The bytes to save.
 * @param fileName - The name the file is saved under.
 */
export function downloadFile(blob: Blob, fileName: string) {
	const objectUrl = URL.createObjectURL(blob);
	const anchor = document.createElement("a");
	anchor.href = objectUrl;
	anchor.download = fileName;
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
	setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
}
